import Vue from 'vue';
import __vue_component__ from '../icons/Icon.vue.js';

/**
 * @deprecated Use SdsCheckbox instead
 */
var script = Vue.extend({
    name: 'SbCheckbox',
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        size: {
            type: String,
            required: false,
            default: 'regular',
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: '',
        },
        subtext: {
            type: String,
            required: false,
            default: '',
        },
        errorMessage: {
            type: String,
            required: false,
            default: '',
        },
    },
    methods: {
        onChange: function (event) {
            var checked = event.target.checked;
            this.$emit('input', checked);
        },
    },
    components: {
        Icon: __vue_component__,
    },
});

export default script;
